export function setCookie (cookieName, cookieID, domain) {
  if (!domain) {
    const hostname = window.location.hostname
    domain = hostname === 'localhost' ? 'localhost' : '.' + hostname.split('.').slice(-2).join('.')
  }

  const date = new Date()
  date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000))
  const cookie = cookieName + '=' + cookieID + '; expires=' + date.toGMTString() + '; domain=' + domain + '; path=/; SameSite=None; Secure'
  document.cookie = cookie
}

function getOrdinal (n) {
  const ord = ['st', 'nd', 'rd']
  const exceptions = [11, 12, 13]
  const nth = ord[(n % 10) - 1] === undefined || exceptions.includes(n % 100) ? 'th' : ord[(n % 10) - 1]
  return n + nth
}

function formatDate (date) {
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  const td = (new Date(date))
  return getOrdinal(td.getDate()) + ' ' + months[td.getMonth()] + ', ' + td.getFullYear()
}

function formatQuantity (quantity) {
  const format = quantity.map(item => `${item.type}: ${item.pax}`).join(', ')
  return format
}

// TW: https://api.cartstack.com/js/customer-tracking/www.takewalks.com_7394c3faa358622c84987f093785b7da.js
// WOI: https://api.cartstack.com/js/customer-tracking/Take_Walks_70b6229d8f72f89688cc42f265c228e8.js
// DT: https://api.cartstack.com/js/customer-tracking/devourtours.com_9281a67a1374ddf9543e5ba2883e28be.js
// cs_product_name
// cs_parent_url
// cs_tour_date
// cs_quantity
// cs_city
export function setCsCookie ({
  csCity,
  csTourDate,
  csProductName,
  csQuantity
}) {
  try {
    csCity && setCookie('cs_city', csCity)
    csQuantity && setCookie('cs_quantity', formatQuantity(csQuantity))
    csProductName && setCookie('cs_product_name', csProductName)
    csTourDate && setCookie('cs_tour_date', formatDate(csTourDate))
  } catch (error) {
    console.error('Error setting CS cookies:', error)
  }
}

export function formatBookingQuantity (booking) {
  const unitItems = booking && booking.unitItems ? booking.unitItems : []

  const items = [
    { label: 'Adult', unitType: 'ADULT', count: 0 },
    { label: 'Senior', unitType: 'SENIOR', count: 0 },
    { label: 'Infant', unitType: 'INFANT', count: 0 },
    { label: 'Child', unitType: 'CHILD', count: 0 }
  ].map((i) => {
    return { ...i, count: unitItems.filter(unit => unit.unitType === i.unitType).length }
  })

  const text = items
    .filter(i => i.count > 0)
    .map(i => `${i.label}: ${i.count}`)
    .join(', ')

  return text
}

export function setCsCookies (ventrataOrder) {
  try {
    if (!ventrataOrder) {
      return
    }

    const { bookings = [] } = ventrataOrder

    if (bookings.length === 0) {
      return
    }

    let titles = []
    let quantities = []
    let city = ''
    let tourDate = ''

    for (const booking of bookings) {
      const metadata = booking.metadata.shortTitle || ''
      const location = booking.product.location || ''
      const localDateTimeStart = booking.availability.localDateTimeStart || ''

      titles = [...titles, metadata]
      quantities = [...quantities, formatBookingQuantity(booking)]
      city = location
      tourDate = localDateTimeStart ? formatDate(localDateTimeStart) : tourDate
    }

    const title = titles.join(', ')
    const quantity = quantities.join(' | ')

    city && setCookie('cs_city', city)
    quantity && setCookie('cs_quantity', quantity)
    title && setCookie('cs_product_name', title)
    tourDate && setCookie('cs_tour_date', tourDate)
  } catch (error) {
    console.error('Error setting CS cookies:', error)
  }
}
